/**
 * @module CustomAdaptiveCard
 */

import { AdaptiveCard, setProperty, getBoolValue, IValidationError } from 'adaptivecards';

/**
 * @class
 * A customized class for AdaptiveCard type
 */
export default class CustomAdaptiveCard extends AdaptiveCard {
    /**
     * @public
     * A method to construct JSON out of Actionable MessageCard
     * @returns A JSON object of a card
     */

    public toJSON(): any {
        const result = super.toJSON();
        setProperty(result, 'rtl', this.rtl, false);
        return result;
    }

    /**
     * @public
     * A method which parses the JSON payload and constructs Actionable MessageCard out of it
     * @param json A JSON object representing the card data
     * @param errors A list of errors on validation
     * @returns nothing
     */

    public parse(json: any, errors?: Array<IValidationError>): void {
        super.parse(json, errors);
        this.rtl = getBoolValue(json.rtl, this.rtl);
    }
}
